/**
 * Detects if the code is running in a visual regression test context.
 * Works in both SSR (server-side) and CSR (client-side) contexts.
 *
 * @returns true if running in visual test mode
 */
export function isVisualTest(): boolean {
  // SSR context: Check environment variable set by Playwright
  if (process.env.VISUAL_TEST === 'true') {
    return true
  }

  // CSR context: Check if flag was set by Playwright addInitScript
  if (
    typeof window !== 'undefined' && // @ts-expect-error - custom property set by test
    window.__VISUAL_TEST__ === true
  ) {
    return true
  }

  return false
}
